import React from "react";
import "../style/Footer.css";
import iitmlogo from "../resources/iitm_logo.png";

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="logo-section">
          <img
            src={iitmlogo}
            alt="IITM College of Engineering Logo"
            className="footer-logo"
          />
        </div>

        <div className="college-info">
          <h3 className="college-name">IITM College of Engineering</h3>
          <p className="college-approve">
            Approved by AICTE & Affiliated to Maharshi Dayanand University, Rohtak
          </p>

          <address className="college-address">
            Bahadurgarh–Jhajjar Road, Village Lowa Khurd, Near D.P.S<br />
            Bahadurgarh (Delhi NCR) 124507 (Haryana), India.
          </address>
        </div>

        <div className="footer-bottom">
          <p className="copyright">© 2026 ICE</p>
          <p className="credits">
            Developed by <span className="team-name">Virtuality</span>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
